import AssessmentsOverviewPageContent from './AssessmentsOverviewPageContent';
import { AssessmentsOverviewContext } from './Contexts/AssessmentsOverviewContext';
import useAssessmentsOverviewContextValue from './Contexts/UseAssessmentsOverviewContextValue';
import useQuery from '@/Hooks/UseQuery';
import { AssessmentStatuses } from '@/Models/AssessmentData';
import withCompanyProfileRequired from '@/Routing/withCompanyProfileRequired';
import withSignupChecks from '@/Routing/withSignupChecks';
import withTalentMeshUserRequired from '@/Routing/withTalentMeshUserRequired';
import UIStrings from '@/Utils/UIStrings';

const AssessmentsOverviewPage = () => {
    const tab = useQuery('filter');

    let initialStatus = AssessmentStatuses.Active;
    if (tab === UIStrings.Closed.toLowerCase()) {
        initialStatus = AssessmentStatuses.Closed;
    }

    const contextValue = useAssessmentsOverviewContextValue(initialStatus);

    return (
        <AssessmentsOverviewContext.Provider value={contextValue}>
            <AssessmentsOverviewPageContent />
        </AssessmentsOverviewContext.Provider>
    );
};

export default withCompanyProfileRequired(withTalentMeshUserRequired(withSignupChecks(AssessmentsOverviewPage)));
